import { useLocation, useNavigate } from 'react-router'

/** A conversation opened from a search result carries this, so back returns to the results rather than to the chats. */
export const FROM_SEARCH = { from: 'search' } as const

function openedFromSearch(state: unknown): boolean {
  return (state as { from?: string } | null)?.from === FROM_SEARCH.from
}

/**
 * Where a conversation's back (the button and the edge swipe) goes: one step back to the search it was opened from, its
 * words and filters kept in the address, or to the chats.
 */
export function useBack(): { go: () => void; label: string } {
  const location = useLocation()
  const navigate = useNavigate()
  const fromSearch = openedFromSearch(location.state)
  return {
    go: () => (fromSearch ? navigate(-1) : navigate('/')),
    label: fromSearch ? 'Back to search' : 'Back to conversations',
  }
}
